import React, { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
    hash: string;
}

export default function HashedRoute(props: PropsWithChildren<Props>) {
    const location = useLocation();
    if (location.hash !== props.hash) {
        return null;
    }

    return <>{props.children}</>;
}
